import React from 'react';

import { CardListPanel } from '@eika-kortbetjening/card-list-panel';
import { ListPanelWrapper } from '@eika/link-panel';

import { useSession } from '@/components/app/Session';
import { KbjCardService } from '@/domain/card';
import { useOrderNewDebitCardUrl } from '@/hooks/url/use-order-new-debit-card-url';

import { useLinkProducer } from '@domain/app';
import { Card, DebitAccount } from '@generated-types';
import useText from '@hooks/use-text';
import { getCardDetailsUrl } from '@utils/url/get-card-details-url-utils';

import { NoDebitCardsAvailablePanel } from './NoDebitCardsAvailablePanel';
import { OrderNewDebitCardPanel } from './OrderNewDebitCardPanel';

type DebitCardsContentProps = {
    debitCards: Card[];
    debitAccounts: DebitAccount[];
};

export const DebitCardsContent = ({ debitCards, debitAccounts }: DebitCardsContentProps) => {
    const session = useSession();
    const text = useText();
    const orderNewDebitCardUrlQuery = useOrderNewDebitCardUrl();
    const produceLink = useLinkProducer();

    const cards = debitCards.map((card) =>
        KbjCardService.toKbjDebitPanel(
            card,
            session,
            getCardDetailsUrl(produceLink),
            text,
            debitAccounts.find((account) => account.id === card.accountId),
        ),
    );

    return (
        <ListPanelWrapper
            titleContent={<h3 className="card-list-panel-title">{text.debitCardsTitle}</h3>}
            className="card-list-wrapper"
            contentWrapperAs="ul"
        >
            {cards.length > 0 &&
                cards.map(([card, cardMeta]) => (
                    <CardListPanel key={card.number} dictionary={text} card={card} cardMeta={cardMeta} />
                ))}
            {cards.length === 0 && <NoDebitCardsAvailablePanel orderNewDebitCardUrl={orderNewDebitCardUrlQuery.data} />}
            {orderNewDebitCardUrlQuery.data && (
                <OrderNewDebitCardPanel orderNewDebitCardUrl={orderNewDebitCardUrlQuery.data} />
            )}
        </ListPanelWrapper>
    );
};
